import CtrlWorkflowPage from './pages/CtrlWorkflowPage.vue'

const routes = [
  {
    path: 'ctrl-workflow',
    name: 'ctrl-workflow',
    component: CtrlWorkflowPage
  }
];

export default routes;